// import React, { useState, useRef, useEffect } from "react";
// import { FaSearch, FaTimes } from "react-icons/fa";
// import axios from "axios";
// import "./SearchBar.css";

// export default function SearchBar({ products }) {
//     const [open, setOpen] = useState(false);
//     const [query, setQuery] = useState("");
//     const [filtered, setFiltered] = useState([]);
//     const wrapperRef = useRef(null);

//     useEffect(() => {
//         const handleClickOutside = (e) => {
//             if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
//                 setOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     const handleChange = (e) => {
//         const val = e.target.value;
//         setQuery(val);

//         if (val.trim() === "") {
//             setFiltered([]);
//             return;
//         }

//         const result = products
//             .filter((p) =>
//                 p.name?.toLowerCase().includes(val.toLowerCase())
//             )
//             .slice(0, 10);

//         setFiltered(result);
//     };

//     console.log('this is filtered',filtered)

//     return (
//         <div className="urban-search-wrapper" ref={wrapperRef}>
//             <div className="urban-input-box" onClick={() => setOpen(true)}>
//                 <FaSearch className="urban-search-icon" />
//                 <input
//                     type="text"
//                     value={query}
//                     onChange={handleChange}
//                     placeholder="Search for ingredients, products..."
//                 />
//             </div>

//             {open && (
//                 <div className="urban-search-modal">
//                     {/* <div className="urban-search-header">
//                         <input
//                             type="text"
//                             value={query}
//                             onChange={handleChange}
//                             placeholder="Search..."
//                             autoFocus
//                         />
//                         <FaTimes className="urban-close" onClick={() => setOpen(false)} />
//                     </div> */}

//                     <div className="urban-search-content">
//                         <div className="urban-left">
//                             <h4>Products</h4>

//                             {filtered.length === 0 ? (
//                                 <p className="urban-no-results">Start typing to search...</p>
//                             ) : (
//                                 filtered.map((prod) => (
//                                     <div key={prod.id} className="urban-product-item">
//                                         <img src={prod.image_1} alt="" />
//                                         <div>
//                                             <h5>{prod.name}</h5>
//                                             <p>{prod.category}</p>
//                                         </div>
//                                     </div>
//                                 ))
//                             )}
//                         </div>

//                         <div className="urban-right">
//                             <h4>Suggestions</h4>
//                             <div className="urban-suggestions">
//                                 {[
//                                     "shirataki noodles",
//                                     "shirataki rice",
//                                     "sesame oil",
//                                     "chia seeds",
//                                     "brown sugar",
//                                     "seaweed",
//                                     "sushi",
//                                 ].map((s, i) => (
//                                     <p key={i}>{s}</p>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }



// import React, { useState, useRef, useEffect } from "react";
// import { FaSearch, FaTimes } from "react-icons/fa";
// import axios from "axios";
// import "./SearchBar.css";

// export default function SearchBar({ products }) {

//     const [open, setOpen] = useState(false);

//     const [query, setQuery] = useState("");

//     const [activeTab, setActiveTab] = useState("products");

//     const [filtered, setFiltered] = useState([]);

//     const wrapperRef = useRef(null);

//     // ---------- FETCH BRANDS ----------
//     const [brands, setBrands] = useState([]);

//     useEffect(() => {
//         axios.get("https://api.glocart.in/pages/api/api/brands")
//             .then(res => setBrands(res.data))
//             .catch(err => console.error("Brand fetch error:", err));
//     }, []);

//     // ---------- FETCH CATEGORIES ----------
//     const [categoriesp, setCategoriesp] = useState([]);

//     useEffect(() => {
//         fetch("https://api.glocart.in/pages/api/api/categories")
//             .then(res => res.json())
//             .then(data => setCategoriesp(data))
//             .catch(err => console.error("Category fetch error:", err));
//     }, []);

//     // ---------- CLOSE ON CLICK OUTSIDE ----------
//     useEffect(() => {
//         const handleClickOutside = (e) => {
//             if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
//                 setOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     // ---------- SEARCH FILTER ----------
//     const handleChange = (e) => {
//         const val = e.target.value;
//         setQuery(val);

//         if (!val.trim()) {
//             setFiltered([]);
//             return;
//         }

//         const q = val.toLowerCase();

//         if (activeTab === "products") {
//             const result = products
//                 .filter((p) => p.name?.toLowerCase().includes(q))
//                 .slice(0, 12);
//             setFiltered(result);
//         }

//         else if (activeTab === "brands") {
//             const result = brands
//                 .filter((b) => b.name?.toLowerCase().includes(q))
//                 .slice(0, 12);
//             setFiltered(result);
//         }

//         else if (activeTab === "categories") {
//             const result = categoriesp
//                 .filter((c) => c.name?.toLowerCase().includes(q))
//                 .slice(0, 12);
//             setFiltered(result);
//         }
//     };

//     return (
//         <div className="urban-search-wrapper" ref={wrapperRef}>

//             {/* Input box in header */}
//             <div className="urban-input-box" onClick={() => setOpen(true)}>
//                 <FaSearch className="urban-search-icon" />
//                 <input
//                     type="text"
//                     value={query}
//                     onChange={handleChange}
//                     placeholder="Search for ingredients, products, brands..."
//                 />
//             </div>

//             {open && (
//                 <div className="urban-search-modal">

//                     {/* Header Search */}
//                     <div className="urban-search-header">
//                         <input
//                             type="text"
//                             value={query}
//                             onChange={handleChange}
//                             placeholder="Search..."
//                             autoFocus
//                         />
//                         <FaTimes className="urban-close" onClick={() => setOpen(false)} />
//                     </div>

//                     {/* Tabs */}
//                     <div className="urban-tabs">
//                         <p className={activeTab === "products" ? "active" : ""}
//                             onClick={() => { setActiveTab("products"); setQuery(""); setFiltered([]); }}>
//                             Products
//                         </p>

//                         <p className={activeTab === "brands" ? "active" : ""}
//                             onClick={() => { setActiveTab("brands"); setQuery(""); setFiltered([]); }}>
//                             Brands
//                         </p>

//                         <p className={activeTab === "categories" ? "active" : ""}
//                             onClick={() => { setActiveTab("categories"); setQuery(""); setFiltered([]); }}>
//                             Categories
//                         </p>
//                     </div>

//                     {/* Main content */}
//                     <div className="urban-search-content">

//                         {/* LEFT */}
//                         <div className="urban-left">

//                             {filtered.length === 0 ? (
//                                 <p className="urban-no-results">Start typing to search...</p>
//                             ) : (
//                                 filtered.map((item, i) => (
//                                     <div key={i} className="urban-product-item">

//                                         {activeTab === "products" && (
//                                             <img src={item.image_1} alt="" />
//                                         )}

//                                         <div>
//                                             <h5>{item.name}</h5>

//                                             {activeTab === "products" && (
//                                                 <p>{item.category}</p>
//                                             )}

//                                             {activeTab === "brands" && (
//                                                 <p>Brand</p>
//                                             )}

//                                             {activeTab === "categories" && (
//                                                 <p>Category</p>
//                                             )}

//                                         </div>
//                                     </div>
//                                 ))
//                             )}
//                         </div>

//                         {/* RIGHT */}
//                         <div className="urban-right">
//                             <h4>Suggestions</h4>
//                             <div className="urban-suggestions">
//                                 {products.slice(0, 8).map((p) => (
//                                     <p key={p.id}>{p.name}</p>
//                                 ))}
//                             </div>
//                         </div>

//                     </div>

//                 </div>
//             )}

//         </div>
//     );
// }


import React, { useState, useRef, useEffect } from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import axios from "axios";
import "./SearchBar.css";
import { Link, useNavigate } from "react-router-dom";

export default function SearchBar({ products }) {

    const [open, setOpen] = useState(false);

    const [query, setQuery] = useState("");

    const [activeTab, setActiveTab] = useState("products");

    const [filtered, setFiltered] = useState([]);

    const wrapperRef = useRef(null);

    // ---------- FETCH BRANDS ----------
    const [brands, setBrands] = useState([]);

    useEffect(() => {
        axios.get("https://api.glocart.in/pages/api/api/brands")
            .then(res => setBrands(res.data))
            .catch(err => console.error("Brand fetch error:", err));
    }, []);
    console.log('this is brands', brands)
    // ---------- FETCH CATEGORIES ----------
    const [categoriesp, setCategoriesp] = useState([]);

    useEffect(() => {
        fetch("https://api.glocart.in/pages/api/api/categories")
            .then(res => res.json())
            .then(data => setCategoriesp(data))
            .catch(err => console.error("Category fetch error:", err));
    }, []);

    // ---------- CLOSE ON CLICK OUTSIDE ----------
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // ---------- Get correct label for brands/categories ----------
    const getBrandName = (b) => b.name || b.brand_name || b.title || "";
    const getCategoryName = (c) => c.name || c.category_name || c.title || "";

    // ---------- SEARCH FILTER ----------
    const handleChange1 = (e) => {
        const val = e.target.value;
        setQuery(val);

        if (!val.trim()) {
            setFiltered([]);
            return;
        }

        const q = val.toLowerCase();

        if (activeTab === "products") {
            const result = products
                .filter((p) => p.name?.toLowerCase().includes(q))
                .slice(0, 12);
            setFiltered(result);
        }

        else if (activeTab === "brands") {
            const result = brands
                .filter((b) => getBrandName(b).toLowerCase().includes(q))
                .slice(0, 12);
            setFiltered(result);
        }

        else if (activeTab === "categories") {
            const result = categoriesp
                .filter((c) => getCategoryName(c).toLowerCase().includes(q))
                .slice(0, 12);
            setFiltered(result);
        }
    };

    const handleChange = (e) => {
        const val = e.target.value;
        setQuery(val);
        runFilter(val, activeTab);  // ALWAYS re-filter using current tab
    };


    const runFilter = (text, tab) => {
        const q = text.toLowerCase();

        if (!q.trim()) {
            setFiltered([]);
            return;
        }

        if (tab === "products") {
            setFiltered(products.filter(p =>
                // p.name?.toLowerCase().includes(q)
                (p.name ?? "").toString().toLowerCase().includes(q) ||
                (p.category ?? "").toString().toLowerCase().includes(q)
            ));
        }

        if (tab === "brands") {
            setFiltered(brands.filter(b =>
                (b.name || b.brand_name)?.toLowerCase().includes(q)
            ));
        }

        if (tab === "categories") {
            setFiltered(categoriesp.filter(c =>
                (c.name || c.category_name)?.toLowerCase().includes(q)
            ));
        }
    };


    // suggestions 
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        fetch("https://api.glocart.in/pages/api/api/supercategories")
            .then((res) => res.json())
            .then((data) => setCategories(data))
            .catch((err) => console.error("Error fetching data:", err));
    }, []);

    const navigate = useNavigate();

    const handleCuisine = (extraParam) => {

        //navigate(`/food/dummyCat/dummySub/${encodeURIComponent("Indian")}`);


        let path = `/foodCuisines/${encodeURIComponent(extraParam)}`;
        // if (extraParam) {
        //     path += `/${encodeURIComponent(extraParam)}`;
        // }
        navigate(path);
        window.location.reload(); // Then reload
    };
    const closeSearchAndClear = () => {
        setOpen(false);
        setQuery("");
        setFiltered([]);
    };



    return (
        <div className="urban-search-wrapper" ref={wrapperRef}>

            {/* Input box in header */}
            <div className="urban-input-box" onClick={() => setOpen(true)}>
                <FaSearch className="urban-search-icon" />
                <input
                    type="text"
                    value={query}
                    onChange={handleChange}
                    placeholder="Search for ingredients, products, brands..."
                />
            </div>

            {open && (
                <div className="urban-search-modal">

                    {/* Header Search */}
                    <div className="urban-search-header">
                        <input
                            type="text"
                            value={query}
                            onChange={handleChange}
                            placeholder="Search..."
                            autoFocus
                        />
                        <FaTimes className="urban-close" onClick={() => { setOpen(false); setQuery('') }} />
                    </div>
                    <div className="urban-top-row">

                        {/* Tabs */}
                        <div className="urban-tabs">
                            <p className={activeTab === "products" ? "active" : ""}
                                onClick={() => {
                                    setActiveTab("products");
                                    // setQuery(""); setFiltered([]); 
                                    runFilter(query, "products");
                                }}>
                                Products
                            </p>

                            {/* <p className={activeTab === "brands" ? "active" : ""}
                            // onClick={() => { setActiveTab("brands"); setQuery(""); setFiltered([]); }}>
                            onClick={() => {
                                setActiveTab("brands");
                                runFilter(query, "brands");   // << re-run search for new tab
                            }}
                        >
                            Brands
                        </p> */}

                            <p className={activeTab === "categories" ? "active" : ""}
                                onClick={() => {
                                    setActiveTab("categories");
                                    //setQuery(""); setFiltered([]); 
                                    runFilter(query, "categories");
                                }}>
                                Categories
                            </p>



                        </div>


                    </div>


                    {/* Main content */}
                    <div className="urban-search-content">

                        {/* LEFT */}
                        <div className="urban-left">

                            {filtered.length === 0 ? (
                                <p className="urban-no-results">Start typing to search...</p>
                            ) : (
                                filtered.map((item, i) => (
                                    <div key={i} className="urban-product-item">

                                        {/* Product image only for product tab */}
                                        <Link to={`/product/${item.id}`} onClick={closeSearchAndClear} style={{
                                            textDecoration: "none",
                                            color: "black"
                                        }}>
                                            {activeTab === "products" && (
                                                <img src={item.image_1} alt="" />
                                            )}
                                        </Link>
                                        <div>
                                            {/* Correct names for each tab */}
                                            <Link to={`/product/${item.id}`} onClick={closeSearchAndClear} style={{
                                                textDecoration: "none",
                                                color: "black"
                                            }}>
                                                <h5 style={{ fontSize: '13px' }}>

                                                    {activeTab === "products" && item.name}

                                                </h5>
                                            </Link>
                                            <Link to={`/categories/${encodeURIComponent(getCategoryName(item))}`}
                                                onClick={closeSearchAndClear} style={{
                                                    textDecoration: "none",
                                                    color: "black"
                                                }}>
                                                <h5 style={{ fontSize: '13px' }}>

                                                    {/* {activeTab === "brands" && getBrandName(item)} */}
                                                    {activeTab === "categories" && getCategoryName(item)}
                                                </h5>
                                            </Link>
                                            {/* Labels */}


                                            {activeTab === "products" && (
                                                <p style={{ fontSize: '11px' }}>{item.category}</p>
                                            )}

                                            {/* {activeTab === "brands" && (
                                                <p>Brand</p>
                                            )} */}

                                            {/* {activeTab === "categories" && (
                                                <p>Category</p>
                                            )} */}

                                        </div>
                                    </div>
                                ))
                            )}
                        </div>

                        {/* RIGHT */}
                        {/* <div className="urban-right">
                            <h4>Suggestions</h4>
                            <div className="urban-suggestions">
                                {categories.map((p) => (
                                <>
                                    <p key={p.id}>{p.name}</p>
                                     <img
                                        src={item.image}
                                        alt={item.name}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                        }}
                                    />
                                    </>
                                ))}
                            </div>
                        </div> */}
                        <div className="urban-right">

                            <div className="urban-suggestion-title">
                                Suggestions
                            </div>
                            <div className="urban-suggestions">

                                {categories.map((p) => (
                                    <div key={p.id} className="urban-suggestion-item" onClick={() => handleCuisine(p.name)}>

                                        <img
                                            src={p.image}     // image for category
                                            alt={p.name || p.category_name}
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                objectFit: "contain",
                                                marginRight: "10px",
                                                borderRadius: "6px"
                                            }}
                                        />

                                        <p>{p.name}</p>

                                    </div>
                                ))}

                            </div>
                        </div>


                    </div>

                </div>
            )}

        </div>
    );
}
